"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listRequiredCatalogs = void 0;
var _api = require("@focaltec-suite/api");
var listRequiredCatalogs = exports.listRequiredCatalogs = function listRequiredCatalogs(extendedFields, access) {
  var catalogIds = extendedFields.filter(function (el) {
    return el.type === 'CATALOG' && !!el.reference;
  }).map(function (el) {
    return el.reference;
  });
  var tenantId = extendedFields.map(function (el) {
    return el.tenant_id;
  }).find(function (el) {
    return !!el;
  });
  if (tenantId && catalogIds.length > 0) {
    return (0, _api.listCatalogs)(tenantId, {
      ids: catalogIds
    }, {
      access: access
    });
  }
  return (0, _api.emptyPromise)();
};